import { Component } from '@angular/core';
import { NgxSonnerToaster } from 'ngx-sonner';
import { ThemedIconComponent } from '../../atoms/themed-icon/themed-icon.component';

/**
 * Toast outlet component. Place once in the root layout to enable application-wide toasts.
 * Dispatch toasts using the `toast` helper from `ngx-sonner`.
 */
@Component({
  selector: 'ocp-toast',
  imports: [NgxSonnerToaster, ThemedIconComponent],
  template: `
    <ngx-sonner-toaster
      [richColors]="false"
      position="top-right"
      [duration]="life"
      [closeButton]="true"
      [toastOptions]="toastOptions"
      [offset]="offset"
    >
      <ng-container ngProjectAs="[success-icon]">
        <div class="toast-icon">
          <ocp-themed-icon name="toast-check.svg" [size]="18" />
        </div>
      </ng-container>
      <ng-container ngProjectAs="[warning-icon]">
        <div class="toast-icon">
          <ocp-themed-icon name="toast-warning.svg" [size]="18" />
        </div>
      </ng-container>
      <ng-container ngProjectAs="[error-icon]">
        <div class="toast-icon">
          <ocp-themed-icon name="toast-error.svg" [size]="18" />
        </div>
      </ng-container>
      <ng-container ngProjectAs="[info-icon]">
        <div class="toast-icon">
          <ocp-themed-icon name="toast-info.svg" [size]="18" />
        </div>
      </ng-container>
    </ngx-sonner-toaster>
  `,
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  /** Default lifetime for app-level toasts (can be overridden at call-site). */
  readonly life = 5_000;

  /** Distance from the viewport edge, matching the legacy PrimeNG toast's 20px offset. */
  readonly offset = 20;

  /** Global class hooks used to style sonner toasts to match legacy visuals. */
  readonly toastOptions = {
    classes: {
      toast: 'ocp-sonner-toast',
      title: 'ocp-sonner-toast__title',
      description: 'ocp-sonner-toast__description',
      closeButton: 'ocp-sonner-toast__close-button',
      success: 'ocp-sonner-toast--success',
      warning: 'ocp-sonner-toast--warning',
      error: 'ocp-sonner-toast--error',
      info: 'ocp-sonner-toast--info',
    },
  };
}
